<script>
import {defineComponent} from "vue";
//import PlayButton from "@/components/buttons/PlayButton.vue";
import AnimatedPlayButton from "@/components/buttons/AnimatedPlayButton.vue"
import AnimatedRegion from "@/components/block/elements/AnimatedRegion.vue";
import {mapGetters} from "vuex";
import {ACTION_TYPE_ANIMATE} from "@/components/graphics/Graphics";
import blockElementMixin from "@/mixins/blockElementMixin";
//import AdvImageElement from "@/components/graphics/AdvImageElement.vue";

export default defineComponent({
	name: "ProductRegion",
	props: {
		product: {
			type: Object,
			default: () => {
				return {};
			}
		},
		region: {
			type: Object,
			default: () => {
				return {};
			}
		}
	},
	mixins:[blockElementMixin],
	computed: {
		...mapGetters(['productsBySKU']),
		isClickable() {
			if (this.product?.disableClickRegions) return false;
			if (ACTION_TYPE_ANIMATE.includes(this.actionType)) {
				return !!this.productsBySKU[this.sku];
			}
			return true;
		},
		sku() {
			return (this.product.sku || "").toUpperCase().replace(`${this.actionType.toUpperCase()}|`, '').split('|')?.[0].trim();
		},
		isPlayButton() {
			return this.actionType.toLowerCase().includes('play');
		},
		isAnimated() {
			return ACTION_TYPE_ANIMATE.includes(this.actionType);
		},
		isInBlockVideo() {
			return this.actionType.toLowerCase().includes("inblock");
		},
		actionType() {
			return (this.product.actionType || this.product.sku || '').trim();
		},
		comp() {
			if (this.isPlayButton) return AnimatedPlayButton;// PlayButton;
			if (this.isAnimated) return AnimatedRegion;
			if (this.product?.inblockControls && this.isInBlockVideo) {
				//showing playbutton for inblock Video
				return AnimatedPlayButton;
			}
			return "div";
		},
		props() {
			if (this.isAnimated) {
				return {
					product: this.product,
					region: this.region
				}
			} else if(this.isPlayButton || (this.product?.inblockControls && this.isInBlockVideo)) {
				return {
					AnimatedPlayButton
					//src: '/images/play_button.svg'
				}
			}
			return null;
		}
	},
	methods: {
		onClick() {
			console.log('click', this.product, this.region);
			this.$emit('click', this);
		}
	}
});
</script>

<template>
	<component :is="comp"
	           :class="'product-region-item' + (isClickable ? ' clickable' : ' no-click') + (isPlayButton ? '' : '')"
	           @click.native.stop="onClick"
	           @click.stop="onClick"
	           @keyup.native.enter.stop="onClick"
	           @keyup.enter.stop="onClick"
	           v-bind="props"
	           :is-visible="isVisible"
	           :is-in-viewport="isInViewport"
	/>
</template>

<style lang="scss" scoped>
.product-region-item {
  width: 100%;
  height: 100%;

  &.no-click {
	pointer-events: none;
  }

  &.clickable {
	cursor: pointer;
      pointer-events: inherit;
  }
}
</style>
